import { THEMES } from '../../config/themes';
import { useTheme } from '../../hooks/useTheme';

export function ThemeSwitcher(): React.JSX.Element {
  const { theme, setTheme } = useTheme();
  return (
    <div className="theme-switcher" aria-label="Theme selector">
      {THEMES.map((item) => (
        <button
          key={item.id}
          className="theme-dot"
          data-active={theme === item.id}
          onClick={() => setTheme(item.id)}
          title={`${item.label}: ${item.description}`}
          aria-label={`Use ${item.label} theme`}
          type="button"
        >
          {item.label.slice(0, 1)}
        </button>
      ))}
    </div>
  );
}
